import { sis_diemdanh_status } from "../../../models/response/diem-danh/sis_diemdanh_status";
import { eDiemDanhStatusActionTypeIds, IDiemDanhStatusLoadError, IDiemDanhStatusLoadStart, IDiemDanhStatusLoadSuccess } from "../../action-types/diem-danh/IDiemDanhStatusActionTypes";
import { BaseAction } from "../IBaseActionResult";

export const diemDanhStatusActions = {
    loadStart: (): IDiemDanhStatusLoadStart => BaseAction(undefined, eDiemDanhStatusActionTypeIds.LOAD_START),
    loadSuccess: (respone: sis_diemdanh_status[]): IDiemDanhStatusLoadSuccess => BaseAction(respone, eDiemDanhStatusActionTypeIds.LOAD_SUCCESS),
    loadError: (respone: string): IDiemDanhStatusLoadError => BaseAction(respone, eDiemDanhStatusActionTypeIds.LOAD_ERROR),
}